export default "__VITE_ASSET__BFS9WWOa__"